import { NgModule } from "@angular/core";
import { SharedModule } from "projects/my/src/app/shared/shared.module";
import { AccountSetupComponent } from "./features/account-setup/account-setup.component";
import { IdentityVerificationRoutingModule } from "./identity-verification-routing.module";
import { KbaFormComponent } from "./features/kba-form/kba-form.component";
import { VerifyIdentityComponent } from "./features/verify-identity/verify-identity.component";
import { IdentityVerificationModule as IdentityVerificationCommonModule } from "common";
import { VerifyIdentityResultComponent } from './features/verify-identity-result/verify-identity-result.component';

@NgModule({
  imports: [SharedModule, IdentityVerificationRoutingModule, IdentityVerificationCommonModule],
  declarations: [AccountSetupComponent, KbaFormComponent, VerifyIdentityComponent, VerifyIdentityResultComponent],
  exports: [AccountSetupComponent],
})
export class IdentityVerificationModule {}
